import type { Feature } from "@visioni/a3s-features";
import { useSupportUserStatus } from "./UserContext";
import { useTenantFeatures } from "./useTenantFeatures";
import { resolveSupportFeatureAccess, type SupportFeatureAccess } from "./support-feature-access";

/**
 * Access to a surface needing both a support user and a hire feature.
 *
 * The decision lives in {@link resolveSupportFeatureAccess} so it can be unit
 * tested without the React Native module graph.
 */
export function useSupportFeatureAccess(feature: Feature): SupportFeatureAccess {
  return resolveSupportFeatureAccess(useSupportUserStatus(), useTenantFeatures(), feature);
}
